module.exports = __webpack_public_path__ + "static/img/activitySuccessIcon.6aa9e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activitySuccessIcon.png
// module id = M+Mh
// module chunks = 0